export default "__VITE_ASSET__CSxKj4VA__"